// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QrScanModal_modal__\\+64bl {
  padding: 0;
}
@media (min-width: 640px) {
  .QrScanModal_modal__\\+64bl {
    padding: 66px 40px 40px;
  }
}
@media (max-height: 500px) {
  .QrScanModal_modal__\\+64bl {
    padding: 0;
  }
}
.QrScanModal_modal__\\+64bl .modal__inner {
  max-width: none;
  border-radius: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: rgb(0, 0, 0);
}
@media (min-width: 640px) {
  .QrScanModal_modal__\\+64bl .modal__inner {
    max-width: 560px;
    height: auto;
    border-radius: 16px;
    display: block;
    background-color: var(--white);
  }
}
.QrScanModal_modal__\\+64bl .modal__header {
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);
  color: var(--white);
  border: none;
  flex-direction: row-reverse;
  justify-content: flex-end;
  padding-top: 42px;
  padding-bottom: 12px;
  z-index: 1;
  position: relative;
}
@media (min-width: 640px) {
  .QrScanModal_modal__\\+64bl .modal__header {
    background: none;
    color: var(--text-color);
    border-bottom: 1px solid #E0E7EB;
    flex-direction: row;
    justify-content: flex-start;
    padding: 16px;
  }
}
@media (max-height: 500px) {
  .QrScanModal_modal__\\+64bl .modal__header {
    min-height: 50px;
    padding: 12px;
  }
}
.QrScanModal_modal__\\+64bl .modal__close-btn {
  width: 36px;
  height: 36px;
  margin-left: 0;
  margin-right: 24px;
}
@media (min-width: 640px) {
  .QrScanModal_modal__\\+64bl .modal__close-btn {
    width: 28px;
    height: 28px;
    margin-left: auto;
    margin-right: 0;
  }
}
.QrScanModal_modal__\\+64bl .modal__close-btn::before {
  content: "";
  position: relative;
  transform: rotate(135deg) translate(-1px, -1px);
  width: 10px;
  height: 10px;
  border-style: solid;
  border-color: #4B5058;
  border-width: 0 2px 2px 0;
}
@media (min-width: 640px) {
  .QrScanModal_modal__\\+64bl .modal__close-btn::before {
    display: none;
  }
}
.QrScanModal_modal__\\+64bl .modal__close-btn svg {
  display: none;
  color: var(--text-color);
}
@media (min-width: 640px) {
  .QrScanModal_modal__\\+64bl .modal__close-btn svg {
    display: block;
  }
}
.QrScanModal_modal__\\+64bl .modal__title {
  font-size: 24px;
  line-height: 28px;
  font-weight: 500;
}
@media (min-width: 640px) {
  .QrScanModal_modal__\\+64bl .modal__title {
    font-size: 20px;
    line-height: 22px;
    font-weight: 600;
  }
}
.QrScanModal_modal__\\+64bl .modal__body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
@media (min-width: 640px) {
  .QrScanModal_modal__\\+64bl .modal__body {
    display: block;
  }
}
@media (max-height: 500px) {
  .QrScanModal_modal__\\+64bl .modal__body {
    padding: 8px;
  }
}

.QrScanModal_description__CGZsZ {
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 8px;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: calc(50% + 128px + 18px);
  z-index: 1;
}
@media (min-width: 640px) {
  .QrScanModal_description__CGZsZ {
    position: relative;
    left: auto;
    right: auto;
    top: auto;
    text-align: left;
  }
}
.QrScanModal_description__CGZsZ span {
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.48);
  padding: 4px 12px;
  color: var(--white);
}
@media (min-width: 640px) {
  .QrScanModal_description__CGZsZ span {
    background: none;
    padding: 0;
    color: var(--text-color);
  }
}

.QrScanModal_qrWrap__BuFAy {
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 8px;
  width: 100%;
  height: 100%;
}
@media (min-width: 640px) {
  .QrScanModal_qrWrap__BuFAy {
    position: relative;
    left: auto;
    top: auto;
    height: 480px;
  }
}
@media (max-height: 500px) {
  .QrScanModal_qrWrap__BuFAy {
    height: 280px;
  }
}

.QrScanModal_footer__desm7 {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
}
@media (min-width: 640px) {
  .QrScanModal_footer__desm7 {
    margin-top: 8px;
  }
}

@media (max-height: 500px) {
  .QrScanModal_btnBack__RmqW7 {
    height: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/QrScanModal/QrScanModal.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;AACE;EAHF;IAII,uBAAA;EAEF;AACF;AAAE;EAPF;IAQI,UAAA;EAGF;AACF;AACM;EACE,eAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AACR;AACQ;EARF;IASI,gBAAA;IACA,YAAA;IACA,mBAAA;IACA,cAAA;IACA,8BAAA;EAER;AACF;AACM;EACE,iFAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EACA,yBAAA;EACA,iBAAA;EACA,oBAAA;EACA,UAAA;EACA,kBAAA;AACR;AACQ;EAXF;IAYI,gBAAA;IACA,wBAAA;IACA,gCAAA;IACA,mBAAA;IACA,2BAAA;IACA,aAAA;EAER;AACF;AAAQ;EApBF;IAqBI,gBAAA;IACA,aAAA;EAGR;AACF;AAAM;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AAER;AAAQ;EANF;IAOI,WAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;EAGR;AACF;AADQ;EACE,WAAA;EACA,kBAAA;EACA,+CAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;AAGV;AADU;EAVF;IAWI,aAAA;EAIV;AACF;AADQ;EACE,aAAA;EACA,wBAAA;AAGV;AADU;EAJF;IAKI,cAAA;EAIV;AACF;AAAM;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAER;AAAQ;EALF;IAMI,eAAA;IACA,iBAAA;IACA,gBAAA;EAGR;AACF;AAAM;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAER;AAAQ;EALF;IAMI,cAAA;EAGR;AACF;AADQ;EATF;IAUI,YAAA;EAIR;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,6BAAA;EACA,UAAA;AACF;AACE;EAXF;IAYI,kBAAA;IACA,UAAA;IACA,WAAA;IACA,SAAA;IACA,gBAAA;EAEF;AACF;AAAE;EACE,kBAAA;EACA,qCAAA;EACA,iBAAA;EACA,mBAAA;AAEJ;AAAI;EANF;IAOI,gBAAA;IACA,UAAA;IACA,wBAAA;EAGJ;AACF;;AACA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAEF;AAAE;EARF;IASI,kBAAA;IACA,UAAA;IACA,SAAA;IACA,aAAA;EAGF;AACF;AADE;EAfF;IAgBI,aAAA;EAIF;AACF;;AADA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AAIF;AAFE;EALF;IAMI,eAAA;EAKF;AACF;;AADE;EADF;IAEI,YAAA;EAKF;AACF","sourcesContent":[".modal {\r\n  padding: 0;\r\n\r\n  @media (min-width: 640px) {\r\n    padding: 66px 40px 40px;\r\n  }\r\n\r\n  @media (max-height: 500px) {\r\n    padding: 0;\r\n  }\r\n\r\n  :global {\r\n    .modal {\r\n      &__inner {\r\n        max-width: none;\r\n        border-radius: 0;\r\n        height: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        background-color: rgba(0,0,0,1);\r\n\r\n        @media (min-width: 640px) {\r\n          max-width: 560px;\r\n          height: auto;\r\n          border-radius: 16px;\r\n          display: block;\r\n          background-color: var(--white);\r\n        }\r\n      }\r\n\r\n      &__header {\r\n        background: linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%);\r\n        color: var(--white);\r\n        border: none;\r\n        flex-direction: row-reverse;\r\n        justify-content: flex-end;\r\n        padding-top: 42px;\r\n        padding-bottom: 12px;\r\n        z-index: 1;\r\n        position: relative;\r\n\r\n        @media (min-width: 640px) {\r\n          background: none;\r\n          color: var(--text-color);\r\n          border-bottom: 1px solid #E0E7EB;\r\n          flex-direction: row;\r\n          justify-content: flex-start;\r\n          padding: 16px;\r\n        }\r\n\r\n        @media (max-height: 500px) {\r\n          min-height: 50px;\r\n          padding: 12px;\r\n        }\r\n      }\r\n\r\n      &__close-btn {\r\n        width: 36px;\r\n        height: 36px;\r\n        margin-left: 0;\r\n        margin-right: 24px;\r\n\r\n        @media (min-width: 640px) {\r\n          width: 28px;\r\n          height: 28px;\r\n          margin-left: auto;\r\n          margin-right: 0;\r\n        }\r\n\r\n        &::before {\r\n          content: \"\";\r\n          position: relative;\r\n          transform: rotate(135deg) translate(-1px, -1px);\r\n          width: 10px;\r\n          height: 10px;\r\n          border-style: solid;\r\n          border-color: #4B5058;\r\n          border-width: 0 2px 2px 0;\r\n\r\n          @media (min-width: 640px) {\r\n            display: none;\r\n          }\r\n        }\r\n\r\n        svg {\r\n          display: none;\r\n          color: var(--text-color);\r\n\r\n          @media (min-width: 640px) {\r\n            display: block;\r\n          }\r\n        }\r\n      }\r\n\r\n      &__title {\r\n        font-size: 24px;\r\n        line-height: 28px;\r\n        font-weight: 500;\r\n\r\n        @media (min-width: 640px) {\r\n          font-size: 20px;\r\n          line-height: 22px;\r\n          font-weight: 600;\r\n        }\r\n      }\r\n\r\n      &__body {\r\n        flex: 1;\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        @media (min-width: 640px) {\r\n          display: block;\r\n        }\r\n\r\n        @media (max-height: 500px) {\r\n          padding: 8px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.description {\r\n  font-size: 16px;\r\n  line-height: 22px;\r\n  margin-bottom: 8px;\r\n  text-align: center;\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  top: calc(50% + 128px + 18px);\r\n  z-index: 1;\r\n\r\n  @media (min-width: 640px) {\r\n    position: relative;\r\n    left: auto;\r\n    right: auto;\r\n    top: auto;\r\n    text-align: left;\r\n  }\r\n\r\n  span {\r\n    border-radius: 6px;\r\n    background-color: rgba(0,0,0,.48);\r\n    padding: 4px 12px;\r\n    color: var(--white);\r\n\r\n    @media (min-width: 640px) {\r\n      background: none;\r\n      padding: 0;\r\n      color: var(--text-color);\r\n    }\r\n  }\r\n}\r\n\r\n.qrWrap {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  border-radius: 8px;\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  @media (min-width: 640px) {\r\n    position: relative;\r\n    left: auto;\r\n    top: auto;\r\n    height: 480px;\r\n  }\r\n\r\n  @media (max-height: 500px) {\r\n    height: 280px;\r\n  }\r\n}\r\n\r\n.footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: auto;\r\n\r\n  @media (min-width: 640px) {\r\n    margin-top: 8px;\r\n  }\r\n}\r\n\r\n.btnBack {\r\n  @media (max-height: 500px) {\r\n    height: 40px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `QrScanModal_modal__+64bl`,
	"description": `QrScanModal_description__CGZsZ`,
	"qrWrap": `QrScanModal_qrWrap__BuFAy`,
	"footer": `QrScanModal_footer__desm7`,
	"btnBack": `QrScanModal_btnBack__RmqW7`
};
export default ___CSS_LOADER_EXPORT___;
